// extracted by mini-css-extract-plugin
export default {"header":"header-module__header__fty+G","operator":"header-module__operator__yb6xq"};